import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import DataTable, { createTheme } from "react-data-table-component";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import $ from "jquery";
import Select from "react-select";
import { humanize } from "../../services/Util";
import { useNavigate } from "react-router-dom"; 
import {  useSelector} from "react-redux";
import { utcDateTimeWithTimeZoneWithFormat } from "../../services/Util";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import { subtractMonthsToDate,subtractDaysToDate,currentDate } from "../../services/Util";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { handleError } from "../../services/authApiRoutes/APImethods";
import DateFormat from "../../pages/DateFormat";
import {DATE_FORMATS} from "../../services/DateUtil";
export default function AllActivity() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const [currentPage, updateCurrentPage] = useState(1);
  const [pending, setPending] = useState(true);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [activities, setActivity] = useState([]);
  const [dateRange,setDateRange] = useState('')
  const [selectedDuration,setSelectedDuraton] = useState('')
  const paginationRef = useRef();
  const [sortFocus, setsortFocus] = useState('');
  const [projectQueryString,setProjectQueryString] = useState('')
  const [searchString,setSearchString] = useState('')
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const translate = t;
  const navigate = useNavigate()
  const redirectToActivity = (e,actionUrl,activity) =>{
    var projectId = ''
    const url = e.target.href || actionUrl;
    if(activity.entity.entityType === "project"){
      projectId = activity.entity.id
    }
    const urlLastPart = url.split("/").pop()
    var urlParts = url.split("/")
    const urlSecondLast = urlParts[urlParts.length -2]
     if(e.target.href === e.target.baseURI || 
      (activity.recentActivityVO.languageCode !== '' && urlSecondLast === 'language') || 
      urlLastPart === 'translationRequest' || urlSecondLast === 'changeOrder' ||
      urlLastPart === 'bids' || urlSecondLast === 'discussions'
      ){
      e.preventDefault()
      if(activity.recentActivityVO.languageCode !== '' && urlSecondLast === 'language'){
        navigate(`/project/${projectId}`,{state:{langCode:activity.recentActivityVO.languageCode}})
      }
      else if(urlLastPart === 'translationRequest' || urlLastPart === 'bids'){
         navigate(`/project/${projectId}`,{state:{tab:urlLastPart}})
      }
      else if(urlSecondLast === 'changeOrder'){
        navigate(`/project/${projectId}`,{state:{tab:urlLastPart}})
      }
      else if(urlSecondLast === 'discussions'){
        navigate(`/project/${projectId}`,{state:{tab:urlSecondLast,id:urlLastPart}})
      }
      }
  }
  const columns = [
    {
      id: "activities.output",
      name: translate("project_page.activity_name"),
      selector: (row) => row.output,
      sortable: false,
      cell: (row) => {
        if(row.action?.length > 0){
            return (<span dangerouslySetInnerHTML={{ __html: row.output }} onClick={(e)=> redirectToActivity(e,row.action[0].url.substring(row.action[0].url),row)}></span>)
        }else{
            return (<span dangerouslySetInnerHTML={{ __html: row.output }}></span>);
        }

      },
    },
    {
      id: "activities.projectName",
      name:translate("project_listing.project_name"),
      selector: (row) => row.recentActivityVO.projectName,
      
      sortable: false,
      cell: (row) => <span tabIndex='-1'>{row.recentActivityVO.projectName}</span>,
    },
    {
      id: "activities.type",
      name:translate("project_listing.content_source"),
      selector: (row) => row.type,
      sortable: false,
      cell: (row) => <span>{ translate("event_types."+row.type)}</span>,
    },
    {
      id: "activities.createdDate",
      name: translate("project_listing.created_on"),
      selector: (row) => row.createdDate,
      sortable: false,
      cell: (row) => <span tabIndex='-1'>
          <DateFormat date={row.createdDate} format={DATE_FORMATS.SHORT_DATE_TIME} />
      </span>,
    },
  ];
  const months = [
    { label: "Since beginning", value: '' },
    { label: "Last 3 months", value: '3months' },
    { label: "Last 7 days", value: '7days' },
  ];
  
  const getData = (page) => {
    setPending(true);
    getAxiosResponse(APIUrls.ALL_ACTIVITIES + `?page=${page}${dateRange}${searchString}`)
      .then((res) => {
        if (res.data.data?.events?.length !== 0) {
          setActivity(res.data.data?.events);
          setTotalRows(res.data.data.totalCount);
          setTimeout(() => {
            if(sortFocus){
              $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
              setsortFocus('');
            }
            if (paginationRef.current) {
                  $('#'+ paginationRef.current).trigger('focus');
                  paginationRef.current = '';
              }
            }, 300);

        } else {
          setActivity([]);
        }
        setPending(false);
      })
      .catch((err) => {
        handleError(err);
      });
  };
  const handleDurationChange = (val) =>{
   var startDate = ''
    if(val.value === '3months'){
      startDate = subtractMonthsToDate(3)
    }
    if(val.value === '7days'){
      startDate = subtractDaysToDate(7)
    }
    if(startDate !== '' && startDate !==undefined){
      var endDate = currentDate();
      var startDateFormated = utcDateTimeWithTimeZoneWithFormat(startDate,Constants.DATE_FORMAT,custBootstrapDataRedux?.user?.timeZone);
      var endDateFormatted = utcDateTimeWithTimeZoneWithFormat(endDate, Constants.DATE_FORMAT,custBootstrapDataRedux?.user?.timeZone);
      var newDateRange = `&startDate=${startDateFormated}&endDate=${endDateFormatted}`
      setDateRange(newDateRange)
    }else{
      setDateRange('')
    }
    setSelectedDuraton(val.value)
  }

  useEffect(() => {
    getData(currentPage);
  }, [currentPage]);

  useEffect(()=>{
    getData(1);
      
  },[searchString,dateRange])

const searchByProject = (e) =>{
  var value = e.target.value
  let regex = /^[0-9\b]+$/;
  var queryString = ''
    var searchTypeId = regex.test(e.target.value)
  if(value !== ''){
    if(searchTypeId){
      queryString = `&projectId=${value}`
    }else{
      queryString = `&projectName=${value}`
    }
  }else{
    setSearchString('')
    setResetPaginationToggle(false)
  } 
  setProjectQueryString(queryString)
}
const searchProject = (e) =>{
  if(e.code === Constants.ENTER || e.type === Constants.CLICK){
    setResetPaginationToggle(true)
    setSearchString(projectQueryString)
  }
}
  const noDataFoundComponent = () => {
    return (
      <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
    );
  };
  const handlePageChange = (paging) => {
    updateCurrentPage(paging);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };

  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
    $(".rdt_Table").attr("aria-label","Activities");
    $('.rdt_Table input').parent().attr("role","cell")
   })

  useEffect(() => {
    $('.lastdisable').trigger('focus');
  }, []);

  const crumbs = [
    {label:'Activities', url:''},
   ];

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content">
          <div id="content" className="dashboard-wrap">
          <Breadcrumb crumbs={ crumbs } />
            <div className="all-activity-page">
              <div className="white-bg">
                <div className="campaign-name">

                  <button className="back-btn" aria-label="back" onClick={()=>navigate('/dashboard')}>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#4D4D4D"
                      ></path>
                    </svg>
                  </button>
                  <span>{translate("project_listing.all_activities")}</span>
                </div>
                <div className="filter-content flex show-flex">
                    <div className="search activity-search">
                      <input type="text" name="project-search" className="search-control" placeholder="Search by project : Name/ID"
                      title="Search activity by project" id="project-search" onChange={(e)=>searchByProject(e)} onKeyDown={(e)=>searchProject(e)}/>
                      <button  className="submit" aria-label="search" onClick={(e)=>searchProject(e)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none" >
                                        <path d="M9.43839 14.25C12.9291 14.25 15.7589 11.5637 15.7589 8.25C15.7589 4.93629 12.9291 2.25 9.43839 2.25C5.94769 2.25 3.11792 4.93629 3.11792 8.25C3.11792 11.5637 5.94769 14.25 9.43839 14.25Z" stroke="#88888A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M17.3391 15.75L13.9023 12.4875" stroke="#88888A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                    </div>
                    <div className="global-dropdown-block flex justify-end mb-0 filter-inline-list">
                      <Select className="global-dropdown-select" classNamePrefix='cw'
                        value={months.filter(function (option) {
                          return option.value === selectedDuration;
                        })}
                        aria-label="Delivery status"
                        options={months}
                        onChange={e => handleDurationChange(e)}
                      />
                  </div>
                  
                </div>
                
                
                <div className="datatable-block hide-per-page">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={activities}
                    responsive
                    striped
                    pagination
                    paginationResetDefaultPage={resetPaginationToggle}
                    paginationServer
                    pageLength={15}
                    paginationPerPage={15}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    progressPending={pending}
                    paginationRowsPerPageOptions={[15]}
                    pointerOnHover={true}
                    noDataComponent={noDataFoundComponent()}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
